// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../variables.css'","buttonsContainer":"style_buttonsContainer__5-Y7P"};